export const REGISTER_TEACHER_VERIFY_REQUEST = 'REGISTER_TEACHER_VERIFY_REQUEST';
export const REGISTER_TEACHER_VERIFY_SUCCESS = 'REGISTER_TEACHER_VERIFY_SUCCESS';
export const REGISTER_TEACHER_VERIFY_FAILURE = 'REGISTER_TEACHER_VERIFY_FAILURE';

export const REGISTER_TEACHER_RESEND_CODE_REQUEST = 'REGISTER_TEACHER_RESEND_CODE_REQUEST';
export const REGISTER_TEACHER_RESEND_CODE_SUCCESS = 'REGISTER_TEACHER_RESEND_CODE_SUCCESS';
export const REGISTER_TEACHER_RESEND_CODE_FAILURE = 'REGISTER_TEACHER_RESEND_CODE_FAILURE';
